import * as yup from 'yup'

import constants from 'constants/index'

const schema = (isSystemTask = false) => {
  const { TASK_NAME_MAX_LENGTH } = constants.activities

  return yup.object().shape({
    name: yup
      .string()
      .required('Título é obrigatório')
      .max(
        TASK_NAME_MAX_LENGTH,
        `O título deve ter no máximo ${TASK_NAME_MAX_LENGTH} caracteres`,
      ),
    reason: yup.string().required('O campo "Por quê" é obrigatório'),
    description: yup
      .string()
      .required('Descrição é obrigatória')
      .test(
        'not-empty-html',
        'Descrição é obrigatória',
        (val) => !!val && val !== '<p><br></p>' && val.trim() !== '',
      ),
    kanbanColumnId: yup.mixed().nullable().required('Status é obrigatório'),
    departmentIds: yup.mixed().nullable(),
    attachments: yup.mixed().nullable(),
    responsibleIds: isSystemTask
      ? yup.array().nullable()
      : yup
          .array()
          .min(1, 'Responsável é obrigatório')
          .required('Responsável é obrigatório'),
    priority: isSystemTask
      ? yup.string().nullable()
      : yup.string().nullable().required('Prioridade é obrigatória'),
    dueDate: isSystemTask
      ? yup.date().nullable().typeError('Data inválida')
      : yup
          .date()
          .nullable()
          .required('Prazo é obrigatório')
          .typeError('Data inválida'),
  })
}

export default schema
